import { getFullPath, toChecksumAddress, sequence } from './utils';
export class DeterministicWallet {
  async getExtendedPublicKey(derivationPath) {
    const node = await this.getHDNode(derivationPath);
    return node.neuter().extendedKey;
  }

  async getAddressesWithMultipleDPaths(input) {
    const promises = input.map(({
      path,
      limit,
      offset
    }) => () => this.getAddresses({
      path,
      limit,
      offset
    }));
    return sequence(promises).then(results => results.flat());
  }

  async getAddresses({
    path,
    limit,
    offset = 0,
    node
  }) {
    if (path.isHardened) {
      return new Array(limit).fill(undefined).reduce(async (promise, _, index) => {
        const array = await promise;
        const i = offset + index;
        const dPath = getFullPath(path, i);
        const address = await this.getHardenedAddress(path, offset + index);
        return [...array, {
          address,
          dPath,
          index: i,
          dPathInfo: path
        }];
      }, Promise.resolve([]));
    }

    const masterNode = node !== null && node !== void 0 ? node : await this.getHDNode(path);
    return new Array(limit).fill(undefined).map((_, index) => {
      const i = offset + index;
      const dPath = getFullPath(path, i);
      const node = masterNode.derivePath(i.toString(10));
      return {
        address: toChecksumAddress(node.address),
        index: i,
        dPath,
        dPathInfo: path
      };
    });
  }

}
//# sourceMappingURL=deterministic-wallet.js.map